var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var AddNewAdminModal = require("components/appdev/wizards/AddNewAdminModal");
var RosteringMethodModal = require("components/appdev/wizards/RosteringMethodModal");
var SetupChecklistModal = require("components/appdev/wizards/SetupChecklistModal");
var CurrentUser = require("lib/account/CurrentUser");

import { Link } from "react-router-dom";
import ReactSelect from 'react-select';

require("appdev/wizards/district_org_accounts_page.scss");

class DistrictOrgDetailsPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { districtOrg: null };
	}

	//////// MODAL CONTROLLERS ////////

	openAddNewAdminModal(e) {
		$wr.nope(e)
		this.refs.addNewAdminModal.show();
	}

	openRosteringMethodModal(e) {
		$wr.nope(e)
		this.refs.rosteringMethodModal.show();
	}
	
	openSetupChecklistModal(e){
		$wr.nope(e)
		this.refs.setupChecklistModal.show();
	}

	//////// RENDER METHODS ////////

	renderAccessTokenLink() {
		if (this.state.districtOrg.clever_access_tokens.length > 0) {
			var lastTokenId = this.state.districtOrg.clever_access_tokens.sort((a,b) => b.id-a.id)[0].id
			var route = "/clever_access_tokens/" + lastTokenId + "/details";
			return (
				<Link to={ route }>
					View Clever integration details
				</Link>
			);
		}
	}

	renderPrimaryAdmin() {
		var admin = this.state.districtOrg.primary_admin
		if (admin) {
			var route = "/users/" + admin.id + "/details";
			return (
				<div>
					<div className="sectionSubHeader">Primary Admin</div>
					<Link to={route} target="_blank">
						<div className="primaryAdmin">{admin.display_name} | (Admin ID: {admin.id})</div>
					</Link>
				</div>
			)
		} else {
			return (
				<div>
					This district has no primary admin
				</div>
			)
		}
	}

	displaySchoolOrgName(schoolOrg) {
		var route = "/school_orgs/" + schoolOrg.id + "/details/controls";
		return (
			<div key={schoolOrg.id}>
				<Link to={route} target="_blank">
					{schoolOrg.school.name} (ID: {schoolOrg.id}) {schoolOrg.school.state ? `(${schoolOrg.school.state})` : ''}
				</Link>
			</div>
		);
	}
	renderSchoolOrgs() {
		var schoolOrgs = this.state.districtOrg.school_orgs 
		if (!schoolOrgs) {
			return <div>This district has no school orgs</div>
		} else {
			return (
				<div>
					<div className="sectionSubHeader">School Orgs</div>
					<div className="schoolOrgs">
						{_.map(schoolOrgs, (schoolOrg) => {
							return this.displaySchoolOrgName(schoolOrg)
						})}
					</div>
				</div>
			)
		}
	}

	// renders buttons to modify district org
	renderButtonDisplay() {
		return (
			<div className="buttonControls">
				<div className="btn-group">
					<button className="btn buttonPrimary" onClick={this.openAddNewAdminModal}>
						Add Admin
					</button>
					<button className="btn buttonPrimary" onClick={this.openRosteringMethodModal}>
						Rostering Method
					</button>
					<button className="btn buttonPrimary" onClick={this.openSetupChecklistModal}>
						Setup Checklist
					</button>
				</div>
			</div>
		)
	}

	renderSetupChecklist(){
		return <SetupChecklistModal districtOrg={this.state.districtOrg} ref='setupChecklistModal'/>
	}

	renderAddNewAdminModal() {
		return <AddNewAdminModal districtOrg={this.state.districtOrg} ref="addNewAdminModal" />
	}

	renderRosteringMethod() {
		return <RosteringMethodModal districtOrg={this.state.districtOrg} ref="rosteringMethodModal" />
	}

	render() {
		var districtOrg = this.state.districtOrg

		if (districtOrg == null) {
			return (
				<div className="DistrictOrgDetailsPage container">
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		} else {
			var primaryAdmin = this.renderPrimaryAdmin()
			var schoolOrgs = this.renderSchoolOrgs()
			var setupChecklist = this.renderSetupChecklist()
			var tokenLink = this.renderAccessTokenLink()
			var buttonDisplay = this.renderButtonDisplay()
			var addNewAdminModal = this.renderAddNewAdminModal()
			var rosteringMethod = this.renderRosteringMethod()
		}

		var headerDisplay = (
			<div className="headerSection">
				<header className="pageHeader">
					<h1>{ districtOrg.name }</h1>
				</header>
			</div>
		);

		return (
			<div className="districtOrgDetailsPage container">
				{ headerDisplay }
				{ buttonDisplay }
				{ tokenLink }
				{ primaryAdmin }
				{ schoolOrgs }
				{ addNewAdminModal }
				{ rosteringMethod }
				{ setupChecklist }
			</div>
		);
	}

	fetchDistrictOrgDetails() {
		var districtOrgID = this.props.match.params.id;

		// reset only if it's a new school_org
		if ((this.state.districtOrg && (districtOrgID != this.state.districtOrg.id))) {
			this.setState({ districtOrg: null });
		}
		
		if (this.state.districtOrg == null) {
			var embeds = [
				"district_org.primary_admin,district_org.school_orgs,district_org.clever_access_tokens,school_org.school,district_org.prefs,district_org.setup_checklist"
			]

			CurrentUser.api().getDistrictOrg(districtOrgID, { embed: embeds.join(",") }, $wr.apiHandler((response) => {
				this.setState({ districtOrg: response.district_org });
			}));
		}
		
	}

	componentDidUpdate(prevProps) {
		if ($wr.didParamsChange(prevProps, this.props)) {
			this.fetchDistrictOrgDetails();
		}
	}
	componentDidMount() {
		this.fetchDistrictOrgDetails();
	}
};

DistrictOrgDetailsPage.propTypes = PageStrictPropTypes({
});


module.exports = DistrictOrgDetailsPage;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/DistrictOrgDetailsPage.js